import React, { Component } from 'react';
import { connect } from 'react-redux';
import Parser from 'react-html-parser';
import './subscription.css';
import {getSettingValue, scrollTop} from "../../utils/helpers";

class Subscription extends Component {
    state = {
        isMailByDistrict: false
    }

    componentDidMount() {
        scrollTop();
    }

    handleChange = (e) => {
        let value = e.target.value;
        let isMailByDistrict = value === "yes" ? true : false;
        this.setState({ isMailByDistrict })
    }

    render() {
        let { isMailByDistrict } = this.state;
        let { settings } = this.props.settings;
        let mailChimpEmbedCode = getSettingValue('mailchimp_embed_code', settings);

        // if (settings && settings.data) {
        //     for (let i = 0; i < settings.data.length; i++) {
        //         if (settings.data[i]['mailchimp_embed_code']) {
        //             mailChimpEmbedCode = settings.data[i]['mailchimp_embed_code'];
        //         }
        //     }
        // }

        return (
            <section id="subscribeForm">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="hrrp-form">
                                <div className="row">
                                    <div className="hidden-xs col-sm-3">
                                        <div className="form-banner">
                                            <img src="/img/4.png" alt="partner stories" className="img-responsive" />
                                            <div className="overlay-text text-center">
                                                <span className="partner">Subscription</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-xs-12 col-sm-9">
                                        {/*<form className="form-horizontal"*/}
                                        {/*id="">*/}
                                        {/*<div className="form-group">*/}
                                        {/*<label htmlFor="name" className="col-sm-2 control-label">*/}
                                        {/*Full Name <span>*</span>*/}
                                        {/*</label>*/}
                                        {/*<div className="col-sm-10">*/}
                                        {/*<input name="title" type="text" className="form-control" id="name" required />*/}
                                        {/*</div>*/}
                                        {/*</div>*/}
                                        {/*<div className="form-group">*/}
                                        {/*<label htmlFor="email" className="col-sm-2 control-label">*/}
                                        {/*Email <span>*</span>*/}
                                        {/*</label>*/}
                                        {/*<div className="col-sm-10">*/}
                                        {/*<input type="email" className="form-control" name="email" id="email"*/}
                                        {/*required />*/}
                                        {/*</div>*/}
                                        {/*</div>*/}

                                        {/*<div className="form-group">*/}
                                        {/*<label htmlFor="position" className="col-sm-2 control-label">*/}
                                        {/*Position <span>*</span>*/}
                                        {/*</label>*/}
                                        {/*<div className="col-sm-10">*/}
                                        {/*<input type="text" className="form-control" name="position" id="position"*/}
                                        {/*required />*/}
                                        {/*</div>*/}
                                        {/*</div>*/}

                                        {/*<div className="form-group">*/}
                                        {/*<label htmlFor="organization" className="col-sm-2 control-label">*/}
                                        {/*Organization <span>*</span>*/}
                                        {/*</label>*/}
                                        {/*<div className="col-sm-10">*/}
                                        {/*<input type="text" className="form-control" name="organization" id="organization"*/}
                                        {/*required />*/}
                                        {/*</div>*/}
                                        {/*</div>*/}

                                        {/*<div className="form-group">*/}
                                        {/*<label htmlFor="agency" className="col-sm-2 control-label">*/}
                                        {/*Agency Type <span>*</span>*/}
                                        {/*</label>*/}
                                        {/*<div className="col-sm-10">*/}
                                        {/*<select name="" id="" className="form-control">*/}
                                        {/*<option value="">1</option>*/}
                                        {/*<option value="">2</option>*/}
                                        {/*</select>*/}
                                        {/*</div>*/}
                                        {/*</div>*/}

                                        {/*<div className="form-group">*/}
                                        {/*<label htmlFor="number" className="col-sm-2 control-label">*/}
                                        {/*Phone Number*/}
                                        {/*</label>*/}
                                        {/*<div className="col-sm-6">*/}
                                        {/*<input type="text" className="form-control" name="number" id="number"*/}
                                        {/*required />*/}
                                        {/*</div>*/}
                                        {/*</div>*/}

                                        {/*<div className="form-group">*/}
                                        {/*<label htmlFor="" className="control-label col-xs-12">*/}
                                        {/*Would you like to be in mailing list of specific districts?*/}
                                        {/*</label>*/}
                                        {/*<div className="col-xs-12">*/}
                                        {/*<label className="radio-inline">*/}
                                        {/*<input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="yes" onClick={this.handleChange} /> Yes*/}
                                        {/*</label>*/}
                                        {/*<label className="radio-inline">*/}
                                        {/*<input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="no" onClick={this.handleChange} /> No*/}
                                        {/*</label>*/}
                                        {/*</div>*/}

                                        {/*</div>*/}
                                        {/*{*/}
                                        {/*isMailByDistrict &&*/}
                                        {/*<div className="form-group">*/}
                                        {/*<label htmlFor="" className="control-label col-xs-12">*/}
                                        {/*Mailing List*/}
                                        {/*</label>*/}
                                        {/*<div className="checkbox">*/}
                                        {/*<label className="col-xs-12"  >*/}
                                        {/*<input type="checkbox" value="" />*/}
                                        {/*Option two is disabled*/}
                                        {/*</label>*/}
                                        {/*<label className="col-xs-12">*/}
                                        {/*<input type="checkbox" value="" />*/}
                                        {/*Option two is disabled*/}
                                        {/*</label>*/}
                                        {/*</div>*/}

                                        {/*</div>*/}
                                        {/*}*/}


                                        {/*<div className="form-group">*/}
                                        {/*<div className="col-sm-offset-2 col-sm-10 ">*/}
                                        {/*<button type="submit" className="btn btn-danger  pull-right">subscribe</button>*/}
                                        {/*</div>*/}
                                        {/*</div>*/}
                                        {/*</form>*/}

                                        {mailChimpEmbedCode && Parser(String(mailChimpEmbedCode))}

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => {
    return {
        settings: state.settings
    }
}

export default connect(mapStateToProps)(Subscription);